import { render, staticRenderFns } from "./IDownload.vue?vue&type=template&id=3c573bc2&"
import script from "./IDownload.vue?vue&type=script&lang=ts&"
export * from "./IDownload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports